let bookmarks = [];

const updateBookmarkBar = function (_bookmarks) {

    bookmarks = [];
    if(_bookmarks && _bookmarks.length) {
        _bookmarks.forEach(bookmark => {
            bookmarks.push(bookmark);
        });
    }

    document.querySelector('.badge').textContent = bookmarks.length;
    //Reset Bookmarks bar
    let ul = document.querySelector('.bookmark_list');
    ul.innerHTML = '';
    document.querySelector('.bookmark_list').style.display = 'flex';
    document.querySelector('.bookmarks_notice').style.display = 'none';

    if(bookmarks.length > 0) {
        //Update Bookmarks bar
        bookmarks.forEach(bookmark => {
            //Create remove btn
            let removeBtn = document.createElement('a');
            removeBtn.setAttribute('class', 'js-remove-bookmark');
            removeBtn.setAttribute('data-id', bookmark.post_id);
            removeBtn.setAttribute('data-url', bookmark.post_url);
            removeBtn.setAttribute('data-title', bookmark.post_title);
            removeBtn.setAttribute('data-image', bookmark.image_url);
            removeBtn.setAttribute('title', 'Remove Bookmark');
            removeBtn.innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"/></svg>`;
            removeBtn.addEventListener('click', handleRemoveBookmark);

            //Create bookmark element
            let bookmarkElement = document.createElement('a');
            bookmarkElement.setAttribute('href', bookmark.post_url);
            bookmarkElement.innerHTML = bookmark.post_title;

            //Create li element
            let li = document.createElement('li');
            li.appendChild(bookmarkElement);
            li.appendChild(removeBtn);

            //Append li to ul
            ul.appendChild(li);
        });
        document.querySelector('.export-bookmarks').style.display = 'block';
    }else{
        document.querySelector('.bookmark_list').style.display = 'none';
        document.querySelector('.bookmarks_notice').style.display = 'flex';
    }

    //Update bookmark buttons
    const bookmarkBtnList = document.querySelectorAll('.js-handle-bookmark');
    if(bookmarkBtnList.length > 0) {
        bookmarkBtnList.forEach(bookmarkBtn => {
            if(bookmarks.some(function (i) { return i.post_id.includes(bookmarkBtn.getAttribute('data-id'))})){
                bookmarkBtn.classList.add('bookmarked');
            }else{
                bookmarkBtn.classList.remove('bookmarked');
            }
        });
    }
}
const getBookmarks = function () {
    if (typeof member != 'undefined' && member && member.id) {
        fetch(`${server.url}/bookmarks?user_id=${member.id}`)
            .then(res => res.json())
            .then(data => {
                if (data && data.length) {
                    updateBookmarkBar(data);
                }
            }).catch(err => {
                console.log(err)
            });

    }
}

async function addBookmark(bookmark) {
    if (typeof member != 'undefined' && member && member.id) {
        fetch(`${server.url}/bookmarks`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(bookmark)
        }).then(res => res.json())
            .then(data => {
                if (data && data.message) {
                    updateBookmarkBar(data.bookmarks);
                    // alert(data.message);
                }
            }).catch(err => {
                console.log(err);
            });
    }
}

async function removeBookmark(bookmark) {
    if (typeof member != 'undefined' && member && member.id) {
        fetch(`${server.url}/bookmarks`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(bookmark)
        }).then(res => res.json())
            .then(data => {
                if (data && data.message) {
                    updateBookmarkBar(data.bookmarks);
                    // alert(data.message);
                }
            }).catch(err => {
                console.log(err);
            });
    }
}

const initiateBookmarks = function () {
    const bookmarkBtnList = document.querySelectorAll('.js-handle-bookmark');
    if(bookmarkBtnList.length > 0) {
        bookmarkBtnList.forEach(bookmarkBtn => {
            bookmarkBtn.addEventListener('click', handleBookmark);
        });
    }
}
const handleBookmark = function (event) {
    // Save input values in an object
    let bookmarkObject = {
        post_id: event.currentTarget.getAttribute('data-id'),
        post_url: event.currentTarget.getAttribute('data-url'),
        post_title: event.currentTarget.getAttribute('data-title'),
        image_url: event.currentTarget.getAttribute('data-image'),
        user_id: member.id
    }

    if (bookmarks.some(function (i) { return i.post_id.includes(bookmarkObject.post_id)})) {
        removeBookmark(bookmarkObject);
    } else {
        addBookmark(bookmarkObject);
    }
};
const handleRemoveBookmark = function (event) {
    let bookmarkObject = {
        post_id: event.currentTarget.getAttribute('data-id'),
        post_url: event.currentTarget.getAttribute('data-url'),
        post_title: event.currentTarget.getAttribute('data-title'),
        image_url: event.currentTarget.getAttribute('data-image'),
        user_id: member.id
    }
    removeBookmark(bookmarkObject);
};


const exportBookmarks = function () {
    if (typeof member != 'undefined' && member && member.id) {
        fetch(`${server.url}/bookmarks?user_id=${member.id}`)
            .then(res => res.json())
            .then(data => {
                if (data && data.length) {
                    const rows = [
                        ["ID", "TITLE", "URL", "CREATED_ON"],
                    ];
                    data.forEach(function(enst){
                        rows.push([enst.bookmark_id, enst.post_title.replace(/,/g, ''), enst.post_url, enst.created_on]);
                    });
                    
                    let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
                    var encodedUri = encodeURI(csvContent);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", "my_bookmarks.csv");
                    document.body.appendChild(link);
                    link.click();
                }
            }).catch(err => {
                console.log(err)
            });

    }
}

if(typeof member != 'undefined'){
    getBookmarks();
    initiateBookmarks();
}